// The scan log, Stage 5 piece 6. Words: OBSERVATIONS_SCAN_WORDS.md rev 3, section 3 (approved 2026-10-12).
//
// What counts: the guest page opening a real asset at an active site (demo labels count on the demo set).
// Once per phone per 10 minutes per asset. scans/{auto} holds siteNumber, assetId, isDemo, scannedAt
// and a device hash, never a name. Counted, never listed.
// The QEW page shows the count since cutover or since the last Reset Scan Count on the Sites asset page.
//
// Pure: data in, data out. Unit tested.

/** Minutes between counted scans of one asset from one phone. */
export const SCAN_GAP_MINUTES = 10;

/** True when this scan counts: no scan of this asset from this phone in the last 10 minutes. */
export function scanCounts(lastIso: string | null, nowIso: string): boolean {
  if (!lastIso) return true;
  const last = Date.parse(lastIso);
  if (Number.isNaN(last)) return true;
  return Date.parse(nowIso) - last >= SCAN_GAP_MINUTES * 60_000;
}

/** scanGate/{device}_{asset}. Firestore IDs cannot hold a slash. */
export function scanGateId(deviceKey: string, assetId: string): string {
  return `${deviceKey}_${assetId}`.replace(/\//g, "-").slice(0, 300);
}

export interface ScanCountFrom {
  at: string;
  badgeId: string;
  byName: string;
}

/** The asset's reset stamp, or null when the count runs from cutover. */
export function scanCountFromOf(v: unknown): ScanCountFrom | null {
  if (!v || typeof v !== "object") return null;
  const o = v as Record<string, unknown>;
  return typeof o.at === "string" && o.at ? { at: o.at, badgeId: String(o.badgeId ?? ""), byName: String(o.byName ?? "") } : null;
}

/** The line under QR scans on the Sites asset page. */
export function scanCountLine(from: ScanCountFrom | null): string {
  if (!from) return "Counted since cutover.";
  const [y, m, d] = from.at.slice(0, 10).split("-");
  return `Counted since ${m}/${d}/${y}, reset by ${from.byName || from.badgeId}.`;
}
